<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        fill="inherit"
        stroke="none"
        d="M12 21.2v-2h7v-14h-7v-2h7c.55 0 1.02.2 1.41.59.4.39.59.86.59 1.41v14c0 .55-.2 1.02-.59 1.41-.39.4-.86.59-1.41.59h-7Zm-2-4-1.38-1.45 2.56-2.55H3v-2h8.18L8.63 8.65 10 7.2l5 5-5 5Z"
      />
    </svg>
  </span>
</template>
